import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IInsightsCreateBudget, InsightsService, IUploadInsightsBudget } from '@services/insights.service';
import { UploadStatus, ValidatorService } from '@shared/models/fileupload';
import { Observable, Subject, take } from 'rxjs';
import * as XLSX from 'xlsx';

@Injectable({
	providedIn: 'root',
})
export class BudgetvalidatorService implements ValidatorService {
	private convertedJson = '';
	private sheetName = '';
	private statusSubject: Subject<UploadStatus> = new Subject<UploadStatus>();
	public statusSubject$ = this.statusSubject.asObservable();

	private allowedColumns = ['Ordretype', 'DebitorID', 'Debitorgruppe', 'Sælger', 'Distriktkode', 'Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'];

	constructor(
		private insightsService: InsightsService,
		private translate: TranslateService,
	) {}

	validate(files: any[]) {
		console.log(`BudgetValidator: Processing file: ${files[0].name}`);
		const fileReader = new FileReader();
		const budgets: IUploadInsightsBudget[] = [];
		let hasCorrectColumns = false;
		let fileColumns = [];
		const wrongExcelHeaders = [];
		fileReader.readAsBinaryString(files[0]);
		fileReader.onload = (event: any) => {
			const binaryData = event.target.result;
			const workbook = XLSX.read(binaryData, { type: 'binary' });
			workbook.SheetNames.forEach((sheet) => {
				const data = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], {
					defval: '', // Make sure empty columns are included -- https://stackoverflow.com/questions/54852510/xlsx-to-json-with-empty-cells
				});
				fileColumns = Object.keys(data[0]);
				hasCorrectColumns = fileColumns.join('__') === this.allowedColumns.join('__');
				this.sheetName = sheet;
				this.convertedJson = JSON.stringify(data);
				data.forEach((x) => {
					const budget: IUploadInsightsBudget = {
						sheetName: this.sheetName,
						data: x,
					};
					budgets.push(budget);
				});
			});

			if (!hasCorrectColumns) {
				fileColumns.forEach((columnName, index) => {
					if (this.allowedColumns[index] !== columnName) {
						wrongExcelHeaders.push(columnName);
					}
				});
				const errorMessage = this.translate.instant('insights.administration.budgets.upload.wrongexcelheaders', {
					wrongExcelHeaders: wrongExcelHeaders.join(', '),
					correctExcelHeaders: this.allowedColumns.join(', '),
				});
				this.statusSubject.next({ status: 'error', data: errorMessage });
			} else {
				this.saveFile(files, budgets).subscribe((saveStatus) => {
					this.statusSubject.next({ status: 'success', data: saveStatus });
				});
			}
		};
	}

	private saveFile(files, budgets): Observable<any> {
		const createBudget: IInsightsCreateBudget = {
			data: JSON.stringify(JSON.stringify(budgets)),
			name: 'budget',
		};
		return this.insightsService.addBudget(createBudget).pipe(take(1));
	}
}
